/**
 * Helper functions for company-related operations
 */

/**
 * @typedef {Object} Company
 * @property {number} id - The company's ID
 * @property {string} name - The company's name
 * @property {string} created_at - Creation timestamp
 * @property {string} updated_at - Update timestamp
 */

/**
 * Helper function to extract company names from company objects
 * @param {Company[]|string[]} companies - Array of company objects or company name strings
 * @returns {string[]} Array of company name strings
 */
export const extractCompanyNames = (companies) => {
  if (!Array.isArray(companies)) return [];
  return companies.map(company => typeof company === 'string' ? company : company.name).filter(Boolean);
};

